import React from 'react';
import { Box, Typography, IconButton, Link as MuiLink, Button, Stack } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        backgroundImage: 'url("/assets/background4.webp")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: { xs: 10, md: 0 },
        color: 'white',
        overflow: 'hidden',
      }}
    >
      
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(90deg, rgba(2,6,23,0.25) 0%, rgba(2,6,23,0.6) 70%)',
          zIndex: 1,
        }}
      />

      {/* content wrapper */}
      <Box 
        sx={{ 
          position: 'relative', 
          zIndex: 2, 
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          px: { xs: 3, sm: 4, md: 8 },
        }}
      >
        <Box
          sx={{
            maxWidth: 680,
            width: '100%',
            textAlign: 'center',
            background: 'rgba(15,23,42,0.7)',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 4,
            boxShadow: '0 20px 50px rgba(0,0,0,0.35)',
            px: { xs: 3, md: 5 },
            py: { xs: 4, md: 5 },
            backdropFilter: 'blur(6px)',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.2rem', sm: '2.8rem', md: '3.3rem' },
              fontFamily: 'Sora, sans-serif',
              fontWeight: 800,
              color: '#F9FAFB',
              mb: 1,
              lineHeight: 1.1,
            }}
          >
            {t('contact.title')}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Source Sans 3, sans-serif',
              color: '#C7D2FE',
              fontSize: { xs: '1rem', md: '1.1rem' },
              mb: 2.5,
            }}
          >
            {t('contact.subtitle')}
          </Typography>

          <MuiLink
            href={`mailto:${t('contact.email')}`}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              fontSize: { xs: '1rem', md: '1.2rem' },
              color: '#E6EEF6',
              textDecoration: 'none',
              transition: 'color 0.3s ease',
              mb: 2,
              '&:hover': {
                color: '#06B6D4',
              },
            }}
          >
            <EmailIcon fontSize="medium" sx={{ color: '#06B6D4' }} />
            {t('contact.email')}
          </MuiLink>

          <Typography
            sx={{
              fontFamily: 'Source Sans 3, sans-serif',
              color: '#E2E8F0',
              fontSize: { xs: '0.95rem', md: '1.05rem' },
              mb: 3,
            }}
          >
            {t('contact.availability')}
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" sx={{ mb: 2 }}>
            <Button
              href={`mailto:${t('contact.email')}`}
              variant="contained"
              sx={{
                textTransform: 'none',
                fontFamily: 'Sora, sans-serif',
                fontWeight: 700,
                background: '#06B6D4',
                color: '#0B1220',
                '&:hover': { background: '#0891B2' },
              }}
            >
              {t('contact.primaryCta')}
            </Button>
            <Button
              href="https://www.linkedin.com/in/jonatan-nilhamn-3b816b183/"
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              sx={{
                textTransform: 'none',
                fontFamily: 'Sora, sans-serif',
                fontWeight: 700,
                color: '#E6EEF6',
                borderColor: 'rgba(255,255,255,0.35)',
                '&:hover': { borderColor: '#06B6D4', color: '#06B6D4' },
              }}
            >
              {t('contact.secondaryCta')}
            </Button>
          </Stack>

          <Stack direction="row" spacing={1.5} justifyContent="center">
            <IconButton
              component="a"
              href="https://gitlab.com/xcelion"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#E6EEF6', '&:hover': { color: '#06B6D4' } }}
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.linkedin.com/in/jonatan-nilhamn-3b816b183/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#E6EEF6', '&:hover': { color: '#06B6D4' } }}
            >
              <LinkedInIcon />
            </IconButton>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Contact;